export class InspectionListChoiceTypeCollection {
    inspectionListChoiceTypes = [];
}
